import { atom } from 'jotai';
import { atomFamily } from 'jotai/utils';
import { fetchProductInstancesArray } from '~/service/productInstancesService';
import { fetchExpressionById } from '~/service/expressionsService';
import log from '~/logger';
export function getProductInstancesKey(params) {
    return params.projectId || 'null';
}
export const productInstancesAtomFamily = atomFamily((key) => atom(async () => {
    const projectId = key === 'null' ? null : key;
    if (!projectId) {
        return [];
    }
    try {
        const productInstances = await fetchProductInstancesArray({ projectId });
        if (!productInstances.length) {
            return [];
        }
        const expressionIds = [
            ...new Set(productInstances
                .filter((pi) => pi.expressionId != null)
                .map((pi) => pi.expressionId))
        ];
        const expressionPromises = expressionIds.map((id) => fetchExpressionById(id));
        const expressionsResults = await Promise.all(expressionPromises);
        const expressions = expressionsResults.filter((exp) => exp !== null);
        const expressionMap = new Map(expressions.map((exp) => [exp.id, exp]));
        const seasonMap = new Map();
        for (const productInstance of productInstances) {
            if (!productInstance.expressionId) {
                continue;
            }
            const expression = expressionMap.get(productInstance.expressionId);
            if (!expression ||
                !expression.seasons ||
                expression.seasons.length === 0 ||
                !expression.expressionType) {
                continue;
            }
            const season = expression.seasons[0];
            if (!seasonMap.has(season.id)) {
                seasonMap.set(season.id, {
                    id: season.id,
                    name: season.label,
                    variants: []
                });
            }
            const imagePath = '/assets/mockProductMain.png';
            const variant = {
                id: productInstance.id,
                name: expression.expressionType.label,
                subtitle: expression.expressionName,
                units: productInstance.forecast ?? '',
                imagePath
            };
            seasonMap.get(season.id).variants.push(variant);
        }
        for (const season of seasonMap.values()) {
            season.variants.sort((a, b) => a.subtitle.localeCompare(b.subtitle));
        }
        const seasons = Array.from(seasonMap.values());
        seasons.sort((a, b) => a.id.localeCompare(b.id));
        log.info('Product instances transformed', {
            projectId,
            seasonsCount: seasons.length,
            totalVariants: seasons.reduce((sum, s) => sum + s.variants.length, 0)
        });
        return seasons;
    }
    catch (error) {
        log.error('Failed to fetch product instances with expressions', {
            error: error instanceof Error ? error.message : 'Unknown error',
            projectId
        });
        throw error;
    }
}));
